import { useCallback } from 'react';
import { isEscapePressed } from 'utils';
import useKeyDown from 'hooks/useKeyDown';
import { EventListenerConfig } from './useAddEventListener';

export default function useCloseOnEscape(
  onClose: () => void,
  options: EventListenerConfig = {},
) {
  const { enabled = true, capture = false } = options;

  const onKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (isEscapePressed(e)) {
        e.preventDefault();
        e.stopPropagation();

        // don't remove settimeout
        setTimeout(() => {
          onClose();
        }, 0);
      }
    },
    [onClose],
  );

  useKeyDown({ onKeyDown, capture, enabled });
}
